import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

export default function EditSport({
  editVisible,
  setEditVisible,
  results,
  setResults,
  sportInEditIndex,
}) {
  const [editedSport, setEditedSport] = useState(null);

  // Initialize editedSport when dialog opens or sport index changes
  useEffect(() => {
    if (sportInEditIndex !== null) {
      setEditedSport({ ...results.sports[sportInEditIndex] });
    }
  }, [sportInEditIndex, results]);

  const handleSave = () => {
    const updatedSports = results.sports.map((s, i) =>
      i === sportInEditIndex ? editedSport : s
    );
    // Create new results object with updated sport
    const newResults = { ...results, sports: updatedSports };

    setResults(newResults);
    setEditVisible(false);
  };

  if (!editedSport) return null; // prevent rendering before initialization

  const updateCheckbox = (field) => (e) =>
    setEditedSport({ ...editedSport, [field]: e.value });

  return (
    <Dialog
      header=""
      visible={editVisible}
      style={{ width: "450px" }}
      onHide={() => setEditVisible(false)}
      dismissableMask={true}
    >
      <div className="flex flex-col gap-3">
        
        <div style={{ display: 'table', width: '400px' }}>
          {/* Sport Name */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="sportName">Lajin nimi</label>
            </div>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <InputText
                id="sportName"
                value={editedSport.name}
                onChange={(e) => setEditedSport({ ...editedSport, name: e.target.value })}
                style={{ width: '100%' }}
              />
            </div>
          </div>

          {/* Ascending */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="ascending">Pienin tulos voittaa</label>
            </div>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <InputSwitch
                inputId="ascending"
                checked={editedSport.ascending}
                onChange={updateCheckbox("ascending")}
                className="p-inputswitch-sm"
              />
            </div>
          </div>

          {/* Combined */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="combined">Yhdistetty</label>
            </div>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <InputSwitch
                inputId="combined"
                checked={editedSport.combined}
                onChange={updateCheckbox("combined")}
                className="p-inputswitch-sm"
              />
            </div>
          </div>

          {/* Time */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="time">Ajanotto</label>
            </div>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <InputSwitch
                inputId="time"
                checked={editedSport.time}
                onChange={updateCheckbox("time")}
                className="p-inputswitch-sm"
              />
            </div>
          </div>

          {/* Direct points */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="directPoints">Pisteet suoraan (ei sijoituksen mukaan)</label>
            </div>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <InputSwitch
                inputId="directPoints"
                checked={editedSport.directPoints || false}
                onChange={updateCheckbox("directPoints")}
                className="p-inputswitch-sm"
              />
            </div>
          </div>

          {/* Rounds */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
              <label htmlFor="rounds">Kierrokset</label>
            </div>
            <div
              style={{
                display: 'table-cell',
                padding: '0.5rem',
                verticalAlign: 'middle',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
            >
              <div style={{ display: 'table-row' }}>
                <div style={{ display: 'table-cell', padding: '0.5rem' }}>
                  <InputNumber
                    inputId="rounds"
                    value={editedSport.rounds}
                    onValueChange={(e) =>
                      setEditedSport((prev) => ({ ...prev, rounds: e.value }))
                    }
                    showButtons
                    buttonLayout="horizontal"
                    decrementButtonClassName="p-button-outlined p-button-sm"
                    incrementButtonClassName="p-button-outlined p-button-sm"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    min={1}
                    className="p-inputnumber-sm"
                    inputStyle={{ width: '2.5rem', textAlign: 'center' }}
                    style={{ maxWidth: 'fit-content' }}
                    inputRef={(el) => {
                      if (el) el.readOnly = true; // ✅ only the text box is readonly
                    }}
                  />
                </div>
              </div>
              

            </div>
          </div>

          {/* Save Button */}
          <div style={{ display: 'table-row' }}>
            <div style={{ display: 'table-cell', padding: '0.5rem' }}>
              <Button label="Tallenna" onClick={handleSave} className="mt-3" />
            </div>            
            <div style={{ display: 'table-cell', padding: '0.5rem' }}></div>
          </div>
        </div>

      </div>
    </Dialog>
  );
}
